// Full quartz ranges pulled from kalingastone.com and paradigmsurfaces.com (photo-verified models only)
export const KALINGA_RANGE = [
  {
    "name": "Staturio Extra",
    "series": "New Arrivals",
    "image": "/assets/stones/kalinga-staturio-extra.jpg"
  },
  {
    "name": "Miraggio Gold",
    "series": "New Arrivals",
    "image": "/assets/stones/kalinga-miraggio-gold.jpg"
  },
  {
    "name": "Marquina Ultra",
    "series": "New Arrivals",
    "image": "/assets/stones/kalinga-marquina-ultra.jpg"
  },
  {
    "name": "Verde Botanic Classico",
    "series": "New Arrivals",
    "image": "/assets/stones/kalinga-verde-botanic-classico.jpg"
  },
  {
    "name": "Splendor White",
    "series": "New Arrivals",
    "image": "/assets/stones/kalinga-splendor-white.jpg"
  },
  {
    "name": "Sparkle White",
    "series": "New Arrivals",
    "image": "/assets/stones/kalinga-sparkle-white.jpg"
  },
  {
    "name": "Minut White",
    "series": "New Arrivals",
    "image": "/assets/stones/kalinga-minut-white.jpg"
  },
  {
    "name": "Foster Gold",
    "series": "New Arrivals",
    "image": "/assets/stones/kalinga-foster-gold.jpg"
  },
  {
    "name": "Michelangelo",
    "series": "Elixir",
    "image": "/assets/stones/elixir-michelangelo.png"
  },
  {
    "name": "Viola",
    "series": "Elixir",
    "image": "/assets/stones/elixir-viola.png"
  },
  {
    "name": "Blue Crystal Agathe",
    "series": "Elixir",
    "image": "/assets/stones/elixir-blue-crystal-agathe.png"
  },
  {
    "name": "Grand Antique",
    "series": "Elixir",
    "image": "/assets/stones/elixir-grand-antique.png"
  },
  {
    "name": "Bianco Chianti",
    "series": "Elixir",
    "image": "/assets/stones/elixir-bianco-chianti.png"
  },
  {
    "name": "Bianco Crystal",
    "series": "Elixir",
    "image": "/assets/stones/elixir-bianco-crystal.png"
  },
  {
    "name": "Himalaya",
    "series": "Elixir",
    "image": "/assets/stones/elixir-himalaya.jpg"
  },
  {
    "name": "Murano",
    "series": "Terrazzo",
    "image": "/assets/stones/kalinga-terrazzo-murano.jpg"
  },
  {
    "name": "Max Bottichino",
    "series": "Terrazzo",
    "image": "/assets/stones/kalinga-terrazzo-max-bottichino.jpg"
  },
  {
    "name": "Imperial Pink",
    "series": "Terrazzo",
    "image": "/assets/stones/kalinga-terrazzo-imperial-pink.jpg"
  },
  {
    "name": "Imperial Iceberg",
    "series": "Terrazzo",
    "image": "/assets/stones/kalinga-terrazzo-imperial-iceberg.jpg"
  },
  {
    "name": "Imperial Hunter",
    "series": "Terrazzo",
    "image": "/assets/stones/kalinga-terrazzo-imperial-hunter.jpg"
  },
  {
    "name": "Imperial Grey",
    "series": "Terrazzo",
    "image": "/assets/stones/kalinga-terrazzo-imperial-grey.jpg"
  },
  {
    "name": "Imperial Black",
    "series": "Terrazzo",
    "image": "/assets/stones/kalinga-terrazzo-imperial-black.jpg"
  },
  {
    "name": "Blue Terrazzo",
    "series": "Terrazzo",
    "image": "/assets/stones/kalinga-terrazzo-blue.jpg"
  },
  {
    "name": "Turra",
    "series": "Marble",
    "image": "/assets/stones/kalinga-marble-turra.jpg"
  },
  {
    "name": "Reva Beige",
    "series": "Marble",
    "image": "/assets/stones/kalinga-marble-reva-beige.jpg"
  },
  {
    "name": "Pearl Grey",
    "series": "Marble",
    "image": "/assets/stones/kalinga-marble-pearl-grey.jpg"
  },
  {
    "name": "Crema Satin",
    "series": "Marble",
    "image": "/assets/stones/kalinga-marble-crema-satin.jpg"
  },
  {
    "name": "Cotton Crema",
    "series": "Marble",
    "image": "/assets/stones/kalinga-marble-cotton-crema.jpg"
  },
  {
    "name": "Anthracite",
    "series": "Marble",
    "image": "/assets/stones/kalinga-marble-anthracite.jpg"
  },
  {
    "name": "Ottoman Beige",
    "series": "Marble",
    "image": "/assets/stones/kalinga-marble-ottoman-beige.jpg"
  },
  {
    "name": "Candy White",
    "series": "Marble",
    "image": "/assets/stones/kalinga-marble-candy-white.jpg"
  }
];

export const PARADIGM_RANGE = [
  {
    "name": "Calacatta Classic",
    "series": "Calacatta",
    "image": "/assets/stones/paradigm-calacatta-classic.jpg"
  },
  {
    "name": "Calacatta Claudia",
    "series": "Calacatta",
    "image": "/assets/stones/paradigm-calacatta-claudia.jpg"
  },
  {
    "name": "Calacatta Lago",
    "series": "Calacatta",
    "image": "/assets/stones/paradigm-calacatta-lago.jpg"
  },
  {
    "name": "Calacatta Lagoon",
    "series": "Calacatta",
    "image": "/assets/stones/paradigm-calacatta-lagoon.jpg"
  },
  {
    "name": "Calacatta Mirage",
    "series": "Calacatta",
    "image": "/assets/stones/paradigm-calacatta-mirage.jpg"
  },
  {
    "name": "Calacatta Persia",
    "series": "Calacatta",
    "image": "/assets/stones/paradigm-calacatta-persia.jpg"
  },
  {
    "name": "Calacatta Rivero Gold",
    "series": "Calacatta",
    "image": "/assets/stones/paradigm-calacatta-rivero-gold.jpg"
  },
  {
    "name": "Calacatta Venetion",
    "series": "Calacatta",
    "image": "/assets/stones/paradigm-calacatta-venetion.jpg"
  },
  {
    "name": "Carara Spyder",
    "series": "Carrara",
    "image": "/assets/stones/paradigm-carara-spyder.jpg"
  },
  {
    "name": "Carrara Golden Shower",
    "series": "Carrara",
    "image": "/assets/stones/paradigm-carrara-golden-shower.jpg"
  },
  {
    "name": "Carrara Smokey",
    "series": "Carrara",
    "image": "/assets/stones/paradigm-carrara-smokey.jpg"
  },
  {
    "name": "Alaska Gold Light",
    "series": "Classics",
    "image": "/assets/stones/paradigm-alaska-gold-light.jpg"
  },
  {
    "name": "Apache Gold",
    "series": "Classics",
    "image": "/assets/stones/paradigm-apache-gold.jpg"
  },
  {
    "name": "Concrete Grey",
    "series": "Classics",
    "image": "/assets/stones/paradigm-concrete-grey.jpg"
  },
  {
    "name": "Mayra Gold",
    "series": "Classics",
    "image": "/assets/stones/paradigm-mayra-gold.jpg"
  },
  {
    "name": "Rivero Gray",
    "series": "Classics",
    "image": "/assets/stones/paradigm-rivero-gray.jpg"
  },
  {
    "name": "Sorrento",
    "series": "Classics",
    "image": "/assets/stones/paradigm-sorrento.jpg"
  },
  {
    "name": "Titanium Black",
    "series": "Classics",
    "image": "/assets/stones/paradigm-titanium-black.jpg"
  },
  {
    "name": "Black Galaxy",
    "series": "Galaxy",
    "image": "/assets/stones/paradigm-black-galaxy.jpg"
  }
];
